import React from 'react';
import './feature_gallery.css';

var FeatureGallery = function FeatureGallery(props) {
	var images = props.images;
	// TODO - add alt text to the images 

	return React.createElement(
		'section',
		{ className: 'feature-gallery wrapper' },
		React.createElement(
			'div',
			null,
			images[0] && React.createElement('img', { src: images[0].node.productImgMain })
		),
		React.createElement(
			'div',
			null,
			images[1] && React.createElement('img', { src: images[1].node.productImg }),
			images[2] && React.createElement('img', { src: images[2].node.productImg })
		)
	);
};

export default FeatureGallery;